// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2oCWD","inner":"styles_inner__3pI5p","right":"styles_right__3rbXT","close":"styles_close__3MbAd","footer":"styles_footer__1c-Wn"};